module.exports = __webpack_public_path__ + "static/media/post-text.1279dd6c.svg";